import { Stack } from "@mui/material";
import { useMemo } from "react";

import { DatetimeHelper } from "@/common/helpers/datetime";
import { ApiEnumName } from "@/common/services/enum";
import { ScheduleEntryDto, ScheduleEntryDurationType } from "@/core/api/generated/v1";

import Datetime from "../Datetime/Datetime";
import GeneralStrictEntityRelationLink from "../Entity/General/Display/GeneralStrictEntityRelationLink";
import InlineApiEnumValue from "../Enum/InlineApiEnumValue";
import FieldValue from "../Form/Display/FieldValue";
import { ScheduleEntrySourceEntityLink } from "./ScheduleEntrySourceEntityLink";

interface Props {
  entry: ScheduleEntryDto;
  onSourceEntityUpdate: (() => void) | null;
  onSourceEntityDelete: (() => void) | null;
}

export function ScheduleEntryDetails({ entry, onSourceEntityUpdate, onSourceEntityDelete }: Props) {
  const durationHumanized = useMemo(
    () => DatetimeHelper.humanizeDateRangeDuration(entry.startsAt, entry.endsAt),
    [entry],
  );

  return (
    <Stack>
      {/* <Stack>
        <AppTypography variant='h6'>
          <InlineApiEnumValue
            type={ApiEnumName.ScheduleEntryEntityType}
            value={entry.sourceEntity?.entityType}
          />{" "}
          entry
        </AppTypography>
      </Stack> */}

      <Stack gap={0}>
        <FieldValue
          label={
            <InlineApiEnumValue
              type={ApiEnumName.ScheduleEntryEntityType}
              value={entry.sourceEntity?.entityType}
            />
          }
        >
          <ScheduleEntrySourceEntityLink
            entry={entry}
            linkProps={{
              inlineProps: {
                withIcon: true,
                withTooltip: true,
                withActions: true,
                viewProps: {
                  onUpdate: onSourceEntityUpdate,
                  onDelete: onSourceEntityDelete,
                },
              },
            }}
          />
        </FieldValue>

        {entry.durationType === ScheduleEntryDurationType.Point && (
          <>
            <FieldValue label='Date'>
              <Datetime datetime={entry.pointAt} direction='column' withDurationFromNow />
            </FieldValue>
          </>
        )}

        {entry.durationType === ScheduleEntryDurationType.Range && (
          <>
            <FieldValue label='Start'>
              {entry.startsAt ? (
                <Datetime datetime={entry.startsAt} direction='column' withDurationFromNow />
              ) : (
                "Ongoing"
              )}
            </FieldValue>

            <FieldValue label='End'>
              {entry.endsAt ? (
                <Datetime datetime={entry.endsAt} direction='column' withDurationFromNow />
              ) : (
                "Ongoing"
              )}
            </FieldValue>

            <FieldValue label='Duration'>{durationHumanized}</FieldValue>
          </>
        )}

        <FieldValue label='Resource'>
          <GeneralStrictEntityRelationLink
            value={entry.resourceEntity}
            linkProps={{
              inlineProps: {
                withIcon: true,
                withTooltip: true,
                withActions: true,
              },
            }}
          />
        </FieldValue>
      </Stack>
    </Stack>
  );
}
